/**
 * @generated SignedSource<<d322a609df5f77b41c155b6dd039189f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleSearchResultListQuery$data = {
  readonly articleSearch: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly content: {
          readonly " $fragmentSpreads": FragmentRefs<"searchContentItemContent">;
        } | null | undefined;
        readonly id: string;
        readonly score: number | null | undefined;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "articleSearchResultListQuery";
};
export type articleSearchResultListQuery$key = {
  readonly " $data"?: articleSearchResultListQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleSearchResultListQuery">;
};

import searchArticleResultPaginationQuery_graphql from './searchArticleResultPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "articleSearch"
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "articleTypeIds"
    },
    {
      "kind": "RootArgument",
      "name": "contentTypes"
    },
    {
      "kind": "RootArgument",
      "name": "endDate"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "orderBy"
    },
    {
      "kind": "RootArgument",
      "name": "paywallTypeIds"
    },
    {
      "kind": "RootArgument",
      "name": "query"
    },
    {
      "kind": "RootArgument",
      "name": "sectionIds"
    },
    {
      "kind": "RootArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": searchArticleResultPaginationQuery_graphql
    }
  },
  "name": "articleSearchResultListQuery",
  "selections": [
    {
      "alias": "articleSearch",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "articleTypes",
              "variableName": "articleTypeIds"
            },
            {
              "kind": "Variable",
              "name": "contentTypes",
              "variableName": "contentTypes"
            },
            {
              "kind": "Variable",
              "name": "endDate",
              "variableName": "endDate"
            },
            {
              "kind": "Variable",
              "name": "paywallTypeIds",
              "variableName": "paywallTypeIds"
            },
            {
              "kind": "Variable",
              "name": "query",
              "variableName": "query"
            },
            {
              "kind": "Variable",
              "name": "sectionIds",
              "variableName": "sectionIds"
            },
            {
              "kind": "Variable",
              "name": "startDate",
              "variableName": "startDate"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        }
      ],
      "concreteType": "ArticleSearchConnection",
      "kind": "LinkedField",
      "name": "__articleSearchResultListQuery__articleSearch_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleSearchEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleSearchResultItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "score",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "content",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "searchContentItemContent"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "836c23c64f546d8ef6c85c191125342b";

export default node;
